function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();}function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}function _iterableToArrayLimit(arr, i) {if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}
import { logger } from "../logger/Logger";
import { theResourceLoader } from "../resource-loader";
import * as et from "./EventTypes";
import { analytics } from '../analytics';

/**
                                           * The ExtensionManager manages all the extensions available to the viewer.
                                           * Register, retrieve, and unregister your extension using the singleton `Autodesk.Viewing.theExtensionManager`.
                                           *
                                           * You can load/unload your registered extension into a Viewer by invoking 
                                           * {@link #loadExtension|viewer.loadExtension(id, options)} and	
                                           * {@link #unloadExtension|viewer.unloadExtension(id)}, respectively.	
                                           * 	
                                           * @memberof Autodesk.Viewing
                                           * @alias Autodesk.Viewing.ExtensionManager
                                           */var
ExtensionManager = /*#__PURE__*/function () {
  /**
                                              * @memberof Autodesk.Viewing	
                                              * @alias Autodesk.Viewing.ExtensionManager	
                                              * @constructor	
                                              */
  function ExtensionManager() {_classCallCheck(this, ExtensionManager);
    // map of extension id : { EXTENSION_CLASS, externalPathOrCallback, downloadPromise }
    this.registeredExtensions = new Map();
  }

  /**
     * Registers a new extension with the given id.
     *
     * @param {string} extensionId - The string id of the extension.
     * @param {Extension} extensionClass - The Extension-derived class representing the extension.
     * @returns {boolean} - True if the extension was successfully registered.
     * @alias Autodesk.Viewing.ExtensionManager#registerExtension
     */_createClass(ExtensionManager, [{ key: "registerExtension", value: function registerExtension(
    extensionId, extensionClass) {
      if (this.registeredExtensions.has(extensionId)) {
        var extension = this.registeredExtensions.get(extensionId);

        // extension.EXTENSION_CLASS will be present for built-in extension or
        // if the extension has been downloaded and regisrered already
        if (extension.EXTENSION_CLASS) {
          return false;
        } else {
          // We will get here when the extension is downloaded and registered first time
          extension.EXTENSION_CLASS = extensionClass;
        }
      } else {
        this.registeredExtensions.set(extensionId, { EXTENSION_CLASS: extensionClass });
      }
      return true;
    }

    /**
       * Returns the class representing the extension with the given id.
       *
       * @param {string} extensionId - The string id of the extension.
       * @returns {Extension|null} - The Extension-derived class if one was registered; null otherwise.
       * @alias Autodesk.Viewing.ExtensionManager#getExtension
       */ }, { key: "getExtensionClass", value: function getExtensionClass(
    extensionId) {
      if (this.registeredExtensions.has(extensionId)) {
        return this.registeredExtensions.get(extensionId).EXTENSION_CLASS;
      }
      return null;
    }

    /**
       * Unregisters an existing extension with the given id.
       *
       * @param {string} extensionId - The string id of the extension.
       * @returns {boolean} - True if the extension was successfully unregistered.
       * @alias Autodesk.Viewing.ExtensionManager#unregisterExtension
       */ }, { key: "unregisterExtension", value: function unregisterExtension(
    extensionId) {
      if (this.registeredExtensions.has(extensionId)) {
        this.registeredExtensions.delete(extensionId);
        return true;
      }
      return false;
    }

    /**
       * Registers an extension that needs to be downloaded before using it.
       * The Viewer ships with some extensions that are not bundled, but can be runtime-fetched.
       *
       * @param {string} extensionId - The string id of the extension.
       * @param {string | function} urlPathOrCallback - The url from where it needs to be pulled from. Can be a relative or an absolute path.
       *                                                Optionally, this can be a callback function that defers the loading to the client
       *                                                application. Useful for webpack import style loading. Callback must return a promise
       *                                                that resolves when loading is finished.
       * @param {string[]} dependencies               - Optional list of extension IDs, whose bundles are needed before this extension can be built.
       * @returns {boolean} - True if the extension was successfully registered.
       * @alias Autodesk.Viewing.ExtensionManager#registerExternalExtension
       */ }, { key: "registerExternalExtension", value: function registerExternalExtension(
    extensionId, urlPathOrCallback, dependencies) {
      if (this.registeredExtensions.has(extensionId)) {
        return false;
      }
      // EXTENSION_CLASS will be null initially, and set to the class  
      // after the extension is downloaded
      this.registeredExtensions.set(extensionId, { EXTENSION_CLASS: null, externalPathOrCallback: urlPathOrCallback, dependencies: dependencies });
      return true;
    }


    /**
       * Returns the url path from where to download the extension; null if not registered through registerExternalExtension().
       *
       * @param {string} extensionId - The string id of the extension.
       * @returns {url|null} - The url from where to download the extension; null if not download is needed.
       * @alias Autodesk.Viewing.ExtensionManager#getExternalPath
       */ }, { key: "getExternalPath", value: function getExternalPath(
    extensionId) {
      if (this.registeredExtensions.has(extensionId)) {
        return this.registeredExtensions.get(extensionId).externalPathOrCallback;
      }
      return null;
    }

    /**
       * Gets a list of all the extensions that are available for usage.
       * Some are already available in memory, while others may require
       * an additional file to be downloaded prior to its usage.
       * @returns {string[]}
       * @alias Autodesk.Viewing.ExtensionManager#getRegisteredExtensions
       */ }, { key: "getRegisteredExtensions", value: function getRegisteredExtensions()
    {
      return Array.from(this.registeredExtensions).map(function (_ref) {var _ref2 = _slicedToArray(_ref, 2),key = _ref2[0],val = _ref2[1];return {
          id: key,
          inMemory: !!val.EXTENSION_CLASS,
          isAsync: !!val.externalPathOrCallback };});

    }

    /**
       * Download the extension and return its downloading promise
       * @param {string} extensionId 
       * @returns {Promise} resolves when the extension class is ready for usage.
       */ }, { key: "downloadExtension", value: function downloadExtension(
    extensionId) {var _this = this;

      if (!this.registeredExtensions.has(extensionId)) {
        return Promise.reject('Extension not found: ' + extensionId + '. Has it been registered(1)?');
      }

      var extensionState = this.registeredExtensions.get(extensionId);

      if (!extensionState.externalPathOrCallback) {
        return Promise.reject('Extension not found: ' + extensionId + '. Has it been registered(2)?');
      }

      if (extensionState.downloadPromise) {
        // extension download is in progess
        return extensionState.downloadPromise;
      }

      // If the extension has dependencies, download the corresponding bundles first
      var dependencies = extensionState.dependencies || [];
      var dependencyLoads = dependencies.map(function (extId) {return _this.downloadExtension(extId);});
      var dependencyPromise = Promise.all(dependencyLoads);

      extensionState.downloadPromise = dependencyPromise.then(function () {
        if (typeof extensionState.externalPathOrCallback === 'string') {// Create a new download
          return theResourceLoader.loadScript(extensionState.externalPathOrCallback, extensionId);
        } else {// A callback to download was provided, must return a promise
          return extensionState.externalPathOrCallback();
        }
      }).then(function () {
        // No longer need the promise
        delete extensionState.downloadPromise;

        if (!extensionState.EXTENSION_CLASS) {
          // After downloading, the downloaded script would call
          // theExtensionManager.registerExtension(), with the extension class
          // Not having a class means the extension did not call registerExtension
          throw new Error('Extension not found: ' + extensionId + '. Has it been registered(3)?');
        }

        // resolve with the extension class
        return extensionState.EXTENSION_CLASS;
      });

      return extensionState.downloadPromise;
    }

    /**
       * Iterates over each registered Extension class and invokes
       * static method 'populateDefaultOptions' if available.
       * 
       * The objective is to gather all supported configuration options
       * across all extensions.
       * @private
       */ }, { key: "popuplateOptions", value: function popuplateOptions(
    options) {
      this.registeredExtensions.forEach(function (ext) {
        ext.EXTENSION_CLASS.populateDefaultOptions(options);
      });
    }

    /**
       * Is the extension being downloaded?
       * @param {string} extensionId 
       */ }, { key: "isDownloading", value: function isDownloading(
    extensionId) {
      if (this.registeredExtensions.has(extensionId)) {
        return !!this.registeredExtensions.get(extensionId).downloadPromise;
      }
      return false;
    }

    /**
       * Is the extension class available?
       * @param {string} extensionId 
       */ }, { key: "isAvailable", value: function isAvailable(
    extensionId) {
      return !!this.getExtensionClass(extensionId);
    } }]);return ExtensionManager;}();



export var theExtensionManager = new ExtensionManager();

/***
                                                          * Augments a class by extension load/unload functionality.
                                                          */
export var ExtensionMixin = function ExtensionMixin() {};

ExtensionMixin.prototype = {

  /**
                              * Loads the extension with the given id and options.
                              *
                              * @memberof! Autodesk.Viewing.Viewer3D#
                              * @param {string} extensionId - The string id of the extension.
                              * @param {Object} options - An optional dictionary of options.
                              *
                              * @returns {Promise} - Resolves with the extension requested.
                              */
  loadExtension: function loadExtension(extensionId, options) {var _this2 = this;
    // map of extensionId : instance
    this.loadedExtensions = this.loadedExtensions || {};


    // Is the extension registered and the extension
    // constructor available?
    if (theExtensionManager.isAvailable(extensionId)) {
      return this.loadExtensionLocal(extensionId, options);
    }

    // requires download
    this.loadExtensionPromises = this.loadExtensionPromises || {};
    if (extensionId in this.loadExtensionPromises) {
      return this.loadExtensionPromises[extensionId];
    }

    this.loadExtensionPromises[extensionId] = theExtensionManager.downloadExtension(extensionId).then(function () {

      // Don't need the downloading promise anymore
      delete _this2.loadExtensionPromises[extensionId];

      // Abort if a teardown is in progress
      if (!_this2.loadedExtensions) {
        logger.info("Abort loadExtension('".concat(extensionId, "') - teardown in progress"));
        return; // This is not considered an error
      }

      // user unloaded an extension while download is in progress
      if (_this2.cancelledExtensions && extensionId in _this2.cancelledExtensions) {
        delete _this2.cancelledExtensions[extensionId];
        throw new Error("Abort loadExtension('".concat(extensionId, "') - extension has been unloaded"));
      }

      return _this2.loadExtensionLocal(extensionId, options);
    });

    return this.loadExtensionPromises[extensionId];
  },

  /**
      * Returns the loaded extension.
      * @memberof! Autodesk.Viewing.Viewer3D#
      * @param {string} extensionId - The string id of the extension.
      * @param {function} [callback] - That receives an extension instance as argument.
      * @returns {?Object} - Extension.
      */
  getExtension: function getExtension(extensionId, callback) {
    var ext = this.loadedExtensions && extensionId in this.loadedExtensions ? this.loadedExtensions[extensionId] : null;
    if (ext && callback) {
      callback(ext);
    }
    return ext;
  },

  /**
      * Returns a promise with the loaded extension.
      * @memberof! Autodesk.Viewing.Viewer3D#
      * @param {string} extensionId - The string id of the extension.
      * @returns {Promise} - Resolves with the loaded extension.
      */
  getExtensionAsync: function getExtensionAsync(extensionId) {var _this3 = this;
    var extension = this.getExtension(extensionId);

    if (extension) {
      return Promise.resolve(extension);
    } else {
      return new Promise(function (resolve) {
        _this3.addEventListener(et.EXTENSION_LOADED_EVENT, function onExtensionLoaded(event) {
          if (event.extensionId === extensionId) {
            this.removeEventListener(et.EXTENSION_LOADED_EVENT, onExtensionLoaded);
            extension = this.getExtension(extensionId);
            resolve(extension);
          }
        });
      });
    }
  },

  /**
      * Unloads the extension with the given id.
      *
      * @memberof! Autodesk.Viewing.Viewer3D#
      * @param {string} extensionId - The string id of the extension.
      * @returns {boolean} - True if the extension was successfully unloaded.
      */
  unloadExtension: function unloadExtension(extensionId) {
    this.cancelledExtensions = this.cancelledExtensions || {};
    if (theExtensionManager.isDownloading(extensionId)) {
      // cancel mid download
      this.cancelledExtensions[extensionId] = true;
      return false;
    }

    var success = false;
    var ext = this.getExtension(extensionId);

    if (ext) {
      success = ext.unload();
      logger.info('Extension unloaded: ' + extensionId);
      delete this.loadedExtensions[extensionId];

      analytics.track('viewer.extensionManager.extensionUnloaded', {
        extensionId: extensionId });


      this.dispatchEvent({ type: et.EXTENSION_UNLOADED_EVENT, extensionId: extensionId });
    } else {
      logger.warn('Extension not found: ' + extensionId);
    }

    return success;
  },


  /**
      * Loads the extension with the given id and options.
      * For internal use only.
      *
      * @memberof! Autodesk.Viewing.Viewer3D#
      * @param {string} extensionId - The string id of the extension.
      * @param {Object} options - An optional dictionary of options.
      *
      * @returns {Promise} - Resolves with the extension requested.
      */
  loadExtensionLocal: function loadExtensionLocal(extensionId, options) {var _this4 = this;
    // Instantiate the extension
    var EXTENSION_CLASS = theExtensionManager.getExtensionClass(extensionId);
    if (!EXTENSION_CLASS) {
      return Promise.reject('Extension not found : ' + extensionId);
    }

    // Extension already loaded?
    var extension = this.getExtension(extensionId);
    if (extension) {
      return Promise.resolve(extension);
    }

    // Is an extension with async load in progress?
    if (this.loadingExtensions && extensionId in this.loadingExtensions) {
      return this.loadingExtensions[extensionId];
    }

    // Create a new one
    extension = new EXTENSION_CLASS(this, options);
    extension.id = extensionId;

    var loadResult = extension.load();
    if (!loadResult) {
      return Promise.reject('Extension failed to .load() : ' + extensionId);
    }

    var onSuccess = function onSuccess() {
      _this4.loadedExtensions[extensionId] = extension;
      _this4.onPostExtensionLoad(extension);
      logger.info('Extension loaded: ' + extensionId);

      analytics.track('viewer.extensionManager.extensionLoaded', {
        extensionId: extensionId });


      //Queue the extension loaded event, but do not notify immediately.
      //This is because the event handler can try to unload the extension being loaded,
      //which will make the return logic below confused.
      setImmediate(function () {
        if (_this4.getExtension(extensionId)) {
          _this4.dispatchEvent({ type: et.EXTENSION_LOADED_EVENT, extensionId: extensionId });
        }
      });
    };

    if (loadResult instanceof Promise) {
      // We need to know if there is already an async extension load in progress
      this.loadingExtensions = this.loadingExtensions || {};
      this.loadingExtensions[extensionId] = loadResult.then(function () {
        onSuccess();
        return extension;
      }).finally(function () {
        // Extension load eirther succeded or failed
        delete _this4.loadingExtensions[extensionId];
      });

      return this.loadingExtensions[extensionId];
    } else {
      //In case success is not a Promise but a truthy value,
      //set the extension immediately into the loadedExtensions map,
      //in order to support backwards compatibility with callers who do not
      //wait on the returned Promise but try to use the extension immediately after loadExtension returns.
      onSuccess();
      return Promise.resolve(extension);
    }

  },

  /**
      * Virtual method that hooks into the extension's loading process.
      * Gets invoked after {@link Autodesk.Viewing.Extension#load|extension.load()} 
      * but before event `EXTENSION_LOADED_EVENT` gets fired.
      *
      * @virtual
      */
  onPostExtensionLoad: function onPostExtensionLoad(extension) {
    // virtual method //
  },

  /**
      * Iterate over each extension that has been successfully loaded and invokes a callback function for them.
      * @param {function} callback - That receives an extension instance as argument.
      *
      * @example
      *    forEachExtension(function(ext){
      *       console.log(ext.id);
      *    })
      *
      * @memberof! Autodesk.Viewing.Viewer3D#
      */
  forEachExtension: function forEachExtension(callback) {
    var loadedIds = this.loadedExtensions || {};
    for (var id in loadedIds) {
      if (loadedIds.hasOwnProperty(id)) {
        callback(loadedIds[id]);
      }
    }
  },


  apply: function apply(object) {

    var me = ExtensionMixin.prototype;

    object.loadExtension = me.loadExtension;
    object.getExtension = me.getExtension;
    object.getExtensionAsync = me.getExtensionAsync;
    object.unloadExtension = me.unloadExtension;
    object.loadExtensionLocal = me.loadExtensionLocal;
    object.forEachExtension = me.forEachExtension;
    object.onPostExtensionLoad = me.onPostExtensionLoad;

  } };